import { AutoCompleteProps } from 'antd';

import { ADMIN_ROLE_OPTION_LABELS } from '../../constants';

import { ADMIN_ROLES } from '@/services/roles';
import { TAdminRoles } from '@/types.ts';

export const ADMIN_ROLE_OPTIONS: AutoCompleteProps<TAdminRoles>['options'] = ADMIN_ROLES.map(
    (role) => ({
        label: ADMIN_ROLE_OPTION_LABELS[role],
        value: role,
    })
);
